/**************************************************
 * 用户信息
 **************************************************/
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_USERINFO = 'SET_USERINFO';




// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js